module.exports = __webpack_public_path__ + "img/Slide11.982cecee.jpg";